// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__nlASx","container":"App_container__4L7Vo"};